export default __webpack_public_path__ + "static/media/sendMsgIconV2.53ec4816.svg";